import { FORTA_BLUE, FORTA_ERROR, FORTA_WHITE } from '../../../utils/colors';

export const EVV_PAGE_ROOT_SX = {
  width: '100%',
  // The global body and .App styles hide overflow, so this page scrolls itself.
  height: '100vh',
  '@supports (height: 100dvh)': { height: '100dvh' },
  overflowY: 'auto',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: FORTA_WHITE,
  pt: { xs: 7, sm: 10, md: 12.5 },
  px: { xs: 2.5, sm: 3.25 },
  pb: { xs: 4, sm: 2, md: 0 },
};

export const EVV_PAGE_SHELL_SX = {
  width: '100%',
  maxWidth: 725,
};

export const EVV_PAGE_HEADER_SX = {
  height: 92,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: FORTA_BLUE.light1,
  color: FORTA_WHITE,
  px: 3,
};

export const EVV_PAGE_HEADER_TITLE_SX = {
  fontSize: { xs: 24, sm: 28 },
  fontWeight: 700,
};

export const EVV_PAGE_HEADER_META_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 3,
};

export const EVV_PAGE_SESSION_ID_SX = {
  display: { xs: 'none', sm: 'block' },
  fontSize: 22,
};

export const EVV_PAGE_AVATAR_SX = {
  width: 80,
  height: 80,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: FORTA_BLUE.bright,
  color: FORTA_WHITE,
  fontSize: 32,
  fontWeight: 700,
};

export const EVV_PAGE_CONTENT_SX = {
  minHeight: 'calc(100vh - 192px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  pt: 6,
};

export const EVV_PAGE_HEADING_SX = {
  fontSize: 32,
  fontWeight: 400,
  lineHeight: 1.2,
  mb: 8,
};

export const EVV_PAGE_BODY_SX = {
  width: '100%',
  maxWidth: 575,
  fontSize: 22,
  lineHeight: 1.35,
  textAlign: 'left',
};

export const EVV_PAGE_DONE_BODY_SX = {
  ...EVV_PAGE_BODY_SX,
  textAlign: 'center',
};

export const EVV_PAGE_VERIFY_BUTTON_SX = {
  mt: { xs: 6, sm: 8, md: 10 },
  mb: 0,
  width: { xs: '80%', sm: 320 },
  height: 80,
  fontSize: 30,
  fontWeight: 700,
  boxShadow: '0px 8px 12px rgba(18, 78, 120, 0.25)',
};

export const EVV_PAGE_ERROR_SX = {
  mt: 4,
  maxWidth: 575,
  color: FORTA_ERROR,
  fontSize: 16,
};
